import React from 'react'
import { connect } from 'react-redux';
import * as AppActions from '../actions/AppActions';
import CustomForm from './CustomForm'
import ReduxTextField from '../ReduxFormFields/ReduxTextField'
import LoginHeaderText from './LoginHeaderText'
import CustomLink from './CustomLink';
import { formValueSelector } from 'redux-form';
import { RED } from '../constants/index';
import {
  required,
  mobile
} from '../utilities/fieldValidate'
import HeaderImage from './HeaderImage';
import LableWithLoader from './LabelWithLoader';
import CustomTextMessage from './CustomTextMessage';

const selector = formValueSelector('login')

function mapStateToProps(state) {
  return {
    user: state.login.user,
    isLoading: state.login.isLoading,
    hasError: state.login.hasError,
    mobile: selector(state, 'mobile'),
    password_reset: state.pureActionStates.password_reset
  };
}


class LoginBox extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      service: 'metro',
      msg: null
    }
  }

  submit = values => {
    // print the form values to the console
    console.log(values)

    let data = {
      emailMobile: values.mobile,
      pass: values.password,
      rememberMe: 1
    }
    this.props.fetchLoginDetails(data)
  }

  forgotPassword = () => {
    let require = required(this.props.mobile)
    let invalid = mobile(this.props.mobile)
    if (require || invalid) {
      this.props.history.push('/signin/user/v1/forgotPassword')
    }
    else {
      //sending history object to saga for internal route change
      this.props.getHistory(this.props.history)
      let data = {
        mobile: this.props.mobile,
        type: 3
      }
      this.props.sendOTPForgotPass(data)
    }
  }

  loginViaOTP = () => {
    let require = required(this.props.mobile)
    let invalid = mobile(this.props.mobile)
    if (require || invalid) {
      this.props.history.push('/signin/user/v1/loginViaOTP')
    }
    else {
      //sending history object to saga for internal route change
      this.props.getHistory(this.props.history)
      let data = {
        mobile: this.props.mobile,
        type: 1
      }
      this.props.sendOTP(data)
    }
  }

  componentDidMount() {
    const lastLocation = window.location.pathname + window.location.search
    localStorage.setItem('lastLocation', JSON.stringify(lastLocation));
    localStorage.setItem('searchLocation', JSON.stringify(window.location.search));

    //identifying and setting service
    let url = window.location.search
    let searchParams = new URLSearchParams(url)
    const service = searchParams.get('service')
    this.setState({
      service
    })

    //handling msg from url 
    let msg = searchParams.get('msg')
    if (msg) {
      msg = decodeURIComponent(msg)
      this.setState({ msg })
    }
  }

  componentWillUnmount() {
    //unsetting the password reset flag
    this.props.passwordResetFlag(false);
    //to reset the error and isLoading state
    this.props.resetState()
  }

  render() {
    let err = !this.props.isLoading ? this.props.hasError : null
    return (
      <div>
        <HeaderImage />
        <div className='container-fluid'>
          <CustomForm
            {...this.state}
            form_name='login'
            destroy={false}
            isLoading={this.props.isLoading}
            onSubmit={this.submit}
            err={err}
            label={
              <LableWithLoader
                text='Confirm'
                loader={this.props.isLoading}
              />
            }
          >
            <LoginHeaderText />
            {
              this.props.password_reset &&
              <CustomTextMessage
                lineOne='Password reset successfully'
                lineTwo='Please login to continue'
                txtColor={RED}
              />
            }
            {
              this.state.msg && !this.props.password_reset &&
              <CustomTextMessage
                lineOne={this.state.msg}
                txtColor={RED}
              />
            }
            <ReduxTextField
              name='mobile'
              type='text'
              floatingLabelText='Your Email / Mobile Number'
              // maxLength='10'
              autoComplete='off'
              validate={[required]}
            />
            <ReduxTextField
              floatingLabelText='Enter Password'
              autoComplete='off'
              name='password'
              type='password'
            />
            {
              this.state.service != 'metro' &&
              <CustomLink
                name='forgot-password'
                clickLink={this.forgotPassword}
                text='Forgot Password'
              />
            }
            {
              this.state.service != 'metro' &&
              <CustomLink
                name='login-otp'
                clickLink={this.loginViaOTP}
                text='Login Via OTP'
              />
            }
          </CustomForm>
        </div>
      </div>
    );
  }

}

export default connect(mapStateToProps, {
  ...AppActions
})(LoginBox);


// WEBPACK FOOTER //
// ./src/components/LoginBox.js